import React, { useState, useEffect, useCallback } from 'react';
import { Card, Table, Tag, Select, Button, Space, Typography, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { adminAPI } from '../api/admin';

const { Text } = Typography;

const STATUS_COLORS = {
  pending: 'gold',
  completed: 'green',
  failed: 'red',
  refunded: 'purple'
};

export default function TransactionLogManager() {
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1 });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ status: undefined, type: undefined, gateway: undefined });

  const fetchList = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const params = {};
      if (filters.status) params.status = filters.status;
      if (filters.type) params.type = filters.type;
      if (filters.gateway) params.gateway = filters.gateway;
      const { data } = await adminAPI.getAllTransactions(page, 20, params);
      setItems(data.transactions || []);
      setPagination(data.pagination || { total: 0, page: 1, pages: 1 });
    } catch (e) {
      message.error('خطا در دریافت تراکنش‌ها');
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  useEffect(() => { fetchList(1); }, [fetchList]);

  const columns = [
    { title: 'زمان', dataIndex: 'createdAt', width: 150, render: (v) => moment(v).format('YYYY-MM-DD HH:mm') },
    {
      title: 'کاربر',
      dataIndex: 'user',
      render: (u) => u ? <Text>{u.firstName} {u.lastName}</Text> : '—'
    },
    { title: 'مبلغ (تومان)', dataIndex: 'amount', width: 130, render: (v) => Number(v || 0).toLocaleString('fa-IR') },
    { title: 'نوع', dataIndex: 'type', width: 150 },
    { title: 'درگاه', dataIndex: 'gateway', width: 100, render: (g) => <Tag>{g}</Tag> },
    {
      title: 'وضعیت',
      dataIndex: 'status',
      width: 110,
      render: (s) => <Tag color={STATUS_COLORS[s] || 'default'}>{s}</Tag>
    },
    { title: 'شماره رسید', dataIndex: 'receiptNumber', width: 140, render: (v) => v || '—' }
  ];

  return (
    <div>
      <Card
        size="small"
        style={{ marginBottom: 16 }}
        title="فیلترها"
        extra={<Button icon={<ReloadOutlined />} onClick={() => fetchList(pagination.page)}>بروزرسانی</Button>}
      >
        <Space wrap>
          <Select
            allowClear
            placeholder="وضعیت"
            style={{ width: 140 }}
            value={filters.status}
            onChange={(v) => setFilters((f) => ({ ...f, status: v }))}
            options={[
              { value: 'pending', label: 'در انتظار' },
              { value: 'completed', label: 'موفق' },
              { value: 'failed', label: 'ناموفق' },
              { value: 'refunded', label: 'بازگشت‌داده‌شده' }
            ]}
          />
          <Select
            allowClear
            placeholder="نوع"
            style={{ width: 180 }}
            value={filters.type}
            onChange={(v) => setFilters((f) => ({ ...f, type: v }))}
            options={[
              'train_ticket', 'full_package', 'gift_package', 'requirements',
              'initial_galleons', 'galleon_pack', 'galleon_exchange',
              'vault_to_wallet', 'wallet_to_vault', 'shop_purchase', 'admin_adjustment', 'refund'
            ].map((t) => ({ value: t, label: t }))}
          />
          <Select
            allowClear
            placeholder="درگاه"
            style={{ width: 140 }}
            value={filters.gateway}
            onChange={(v) => setFilters((f) => ({ ...f, gateway: v }))}
            options={[
              { value: 'zarinpal', label: 'زرین‌پال' },
              { value: 'zibal', label: 'زیبال' },
              { value: 'oxapay', label: 'OxaPay' }
            ]}
          />
        </Space>
      </Card>

      <Card size="small">
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={items}
          loading={loading}
          pagination={{
            current: pagination.page,
            pageSize: 20,
            total: pagination.total,
            showSizeChanger: false,
            onChange: (p) => fetchList(p)
          }}
        />
      </Card>
    </div>
  );
}
